import { useEffect } from 'react';
import AreasHeroSection from '../components/AreasHeroSection';
import AreasGridSection from '../components/AreasGridSection';

export default function EppingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const bollardTypes = [
    {
      icon: 'ri-arrow-up-down-line',
      title: 'Telescopic Bollards',
      description: 'Retractable bollards perfect for Epping driveways and parking areas. Easy to operate and highly secure.'
    },
    {
      icon: 'ri-arrow-down-circle-line',
      title: 'Fold Down Bollards',
      description: 'Space-saving bollards ideal for Epping residential properties. Simple fold-down mechanism for quick access.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electric Bollards',
      description: 'Automated bollard systems for Epping commercial properties. Remote control operation for maximum convenience.'
    }
  ];

  const whyChooseUs = [
    {
      icon: 'ri-time-line',
      title: 'Fast Response',
      description: 'Quick installation service across Epping and surrounding areas'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guaranteed',
      description: 'Premium bollards with comprehensive warranty coverage'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Local Experts',
      description: 'Experienced team serving Epping for years'
    }
  ];

  const subAreas = [
    'Epping Town Centre',
    'Epping Upland',
    'North Weald',
    'Coopersale',
    'Theydon Bois',
    'Thornwood'
  ];

  return (
    <div className="min-h-screen bg-white pt-16">
      <AreasHeroSection
        title="Bollard Installation in Epping"
        description="Professional bollard installation services in Epping. Protecting your property with high-quality telescopic, fold down, and electric bollards."
        population="11,461"
        area="Epping"
      />

      {/* Bollard Types Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-4">Our Bollard Solutions in Epping</h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            We offer a comprehensive range of bollard installation services tailored to Epping properties
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {bollardTypes.map((type, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow">
                <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center mb-6">
                  <i className={`${type.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{type.title}</h3>
                <p className="text-gray-600">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12">Why Choose Us in Epping</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-black rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-2xl text-yellow-400`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Sub Areas Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-4">Areas We Cover in Epping</h2>
          <p className="text-gray-600 text-center mb-12">
            We provide bollard installation services throughout Epping and surrounding areas
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {subAreas.map((area, index) => (
              <div key={index} className="bg-gray-50 p-4 rounded-lg text-center hover:bg-yellow-400 hover:text-black transition-colors cursor-pointer">
                <i className="ri-map-pin-line text-xl mb-2"></i>
                <p className="font-semibold">{area}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-black text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Secure Your Epping Property?</h2>
          <p className="text-gray-300 mb-8 text-lg">
            Contact us today for a free quote on bollard installation in Epping
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+447834858178" className="bg-yellow-400 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-500 transition-colors inline-flex items-center justify-center">
              <i className="ri-phone-line mr-2"></i>
              Call +44 7834 858178
            </a>
            <a href="/quote" className="bg-white text-black px-8 py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors inline-flex items-center justify-center">
              <i className="ri-file-list-line mr-2"></i>
              Get a Quote
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}